/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const styles = () => ({
    root: {
        textAlign: 'center',
        '& p.planting-zone-heading': {
            textAlign: 'center',
            fontSize: '1.5rem',
            lineHeight: '30px',
            fontWeight: 'bold',
        },
        '& p': {
            marginTop: '0',
            marginBottom: '1.4rem',
        },
        '@media only screen and (max-width: 767px)': {
            '& img#planting-zone-img': {
                width: '100%',
            },
        },
        '& .planting-zone-info-line': {
            maxWidth: '440px',
            margin: '0 auto',
            lineHeight: '20px',
            paddingBottom: '20px',
        },
        '& span.info-text-span': {
            fontSize: '1.125rem',
        },
        '& .heading': {
            margin: '0 auto',
            maxWidth: '350px',
        },
    },
});

const PlantingZone = ({ classes, data }) => {
    const { hero: { title, copy, hero_image_desktop }, seo = {} } = data;
    const imgUrl = hero_image_desktop?.url || null;
    return (
        <>
            {
                seo?.seo_searchable
                    ? (
                        <GraphqlSeoHeadTags seoData={seo} alternativeLang="true" />
                    ) : null
            }
            <div>
                <div id="content-main-planting-zone" className={classes.root}>
                    <br />
                    <div className="heading">
                        {/* <i className="fa fa-map-marker fa-2x" aria-hidden="true" style={{ margin: '20px 7px' }}></i> */}
                        <p role="heading" aria-label="planting zone header" aria-level="1" className="planting-zone-heading">{title}</p>
                    </div>
                    <div className="planting-zone-info-line">
                        <span role="region" aria-label="planting zone description" className="info-text-span">
                            {copy}
                        </span>
                    </div>
                    <div className="planting-zone-img-div">
                        <img id="planting-zone-img" alt="" src={imgUrl} />
                    </div>
                </div>
            </div>
        </>
    );
};

PlantingZone.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(PlantingZone);
